import { useMemo } from "react";
import useSearcherAccommodationInput from "../../../../../../hooks/common/searchers/inputs/useAccommodationInput.js";
import useIsMobile from "../../../../../../hooks/device/useIsMobile.js";
import { useSearcherFlightHotelProps, useSearcherFlightHotelState } from "../../context/index.js";
import useSearcherFlightHotelDefaultValues from "../../hooks/useSearcherFlightHotelDefaultValues.js";
const useAccommodationInput = ()=>{
    const props = useSearcherFlightHotelProps();
    const { config  } = props ?? {};
    const { literals , onModal =false  } = config ?? {};
    const state = useSearcherFlightHotelState();
    const { isLoading  } = state ?? {};
    const isMobile = useIsMobile();
    const defaultValues = useSearcherFlightHotelDefaultValues(props);
    const accommodationInput = useSearcherAccommodationInput({
        name: 'accommodation',
        label: literals?.accommodationLabel,
        defaultValue: defaultValues.accommodation,
        literals,
        disabled: isLoading
    });
    const tooltipOptions = useMemo(()=>({
            strategy: onModal ? 'fixed' : undefined
        }), [
        onModal
    ]);
    if (isMobile) {
        return accommodationInput;
    }
    return {
        ...accommodationInput,
        tooltipOptions
    };
};
export default useAccommodationInput;

//# sourceMappingURL=useAccommodationInput.js.map